import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../CSS/Testimonial.css';
import axios from 'axios';

const Testimonial = () => {
  const [testimonialData, setTestimonialData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTestimonialData = async () => {
      try {
        const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getTestimonial");
        console.log('Fetched slide data:', response.data); 
        setTestimonialData(response.data || []);
      } catch (error) {
        console.error('Error fetching data from backend:', error);
        setError('Failed to load testimonials. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonialData();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true }},
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 }}
    ]
  };

  if (loading) return <p>Loading testimonials...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="ftco-section testimony-section">
      <div className="container">
        <div className="row justify-content-center mb-5 pb-3">
          <div className="col-md-7 text-center heading-section">
            <h2 className="mb-2 blackthemegradient" >Testimonial</h2>
            <span className="subheading">Our Happy Customers Say</span>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 slidertesti">
            <Slider {...settings}>
              {testimonialData.map(testimonial => (
                <div key={testimonial.time} className="item" style={{ marginRight: "10px" }}>
                  <div className="card" style={{ border: "none", boxShadow: "0 4px 8px rgb(133, 63, 145)" }}>
                    <div className="card-body text-center" style={{ height: "500px" }}>
                      {/* <img
                        src={testimonial.profile_photo_url}
                        alt={`${testimonial.author_name}'s profile`}
                        style={{ borderRadius: '50%', width: '80px', height: '80px', objectFit: 'cover' }}
                      /> */}
                      <h5 className="card-title mt-3" style={{ fontWeight: 'bold', color: "#853f91" }}>{testimonial.author_name}</h5>
                      <p className="card-text mt-1" style={{ textAlign: "justify", maxHeight: "200px", overflow: "hidden", textOverflow: "ellipsis", color: "white" }}>
                        {testimonial.text}
                      </p>
                      <p className="mt-2" style={{ color: "white" }}>Rating: {testimonial.rating} ⭐</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
